import validator from 'validator'
export default validator
